"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqModel = void 0;
const FaqModel = {
    type: Array,
    items: {
        type: Object,
        schema: {
            question: { type: String },
            answer: { type: String },
            index: { type: Number },
            isCustom: { type: Boolean },
        },
    },
};
exports.FaqModel = FaqModel;
